import React, { memo } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😩',
  title: 'Llegás sin saber qué hacer',
  desc: 'Improvisás el encuentro o repetís lo mismo de siempre porque no encontraste nada mejor.'
}, {
  emoji: '🕐',
  title: 'Perdés horas buscando en YouTube',
  desc: 'Terminás con 20 pestañas abiertas y nada concreto para usar el domingo.'
}, {
  emoji: '😶',
  title: 'Los niños se aburren o se dispersan',
  desc: 'Sin una dinámica atractiva, el grupo se desconecta a los 10 minutos.'
}, {
  emoji: '📄',
  title: 'Solo tenés fichas para colorear',
  desc: 'Querés recursos variados pero no sabés dónde encontrarlos ni cómo estructurarlos.'
}, {
  emoji: '🤷',
  title: 'No sabés cómo generar reflexión',
  desc: 'Los temas de fe se vuelven monólogos porque no tenés preguntas ni disparadores listos.'
}, {
  emoji: '⏰',
  title: 'El tiempo de preparación es un problema',
  desc: 'Tenés trabajo, familia y poco tiempo. Planificar se convierte en una carga.'
}, {
  emoji: '🔄',
  title: 'Siempre el mismo formato',
  desc: 'Hablás, rezás, coloreás. Los chicos ya saben lo que viene y les cuesta conectarse.'
}, {
  emoji: '😕',
  title: 'Fin del mes sin que los niños recuerden nada',
  desc: 'Sin una estructura memorable, los valores no se quedan en los chicos.'
}];
export function PainPoints() {
  return <section className="py-10 md:py-20 px-4 md:px-6" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <div className="text-center mb-8 md:mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy-900 mb-2 md:mb-4" data-id="element-152">
            ¿Te pasa esto?
          </h2>
          <p className="text-base md:text-xl text-navy-900/70" data-id="element-153">
            Si trabajás con niños en catequesis, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-10 md:mb-16" data-id="element-154">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02,
          borderColor: '#c8a24a',
          backgroundColor: '#faf4e8'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-cream-200 flex gap-3 md:gap-4 items-start cursor-default" data-id="element-155">
              <div className="text-2xl md:text-3xl shrink-0" data-id="element-156">{point.emoji}</div>
              <div data-id="element-157">
                <h4 className="font-bold text-navy-900 text-base md:text-lg mb-1" data-id="element-158">
                  {point.title}
                </h4>
                <p className="text-navy-900/70 text-sm md:text-base leading-snug" data-id="element-159">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-160">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-gold-600 italic px-4" data-id="element-161">
            ¿Cuántos encuentros más vas a preparar improvisando a último
            momento?
          </h3>
        </div>
      </div>
    </section>;
}